import PropTypes from 'prop-types';
import React from 'react';
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import COLORS from '../constants/colors';

const styles = {
  group: {
    marginTop: 10,
    marginBottom: 10,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'flex-start',
  },
  checkbox: {
    margin: 0,
    paddingLeft: 4,
    paddingRight: 4,
    borderColor: COLORS.MAIN_WHITE,
    borderWidth: 2,
    borderRadius: 5,
    borderStyle: 'solid',
  },
  labelWrapper: {
    flex: 1,
    paddingLeft: 8,
  },
  label: {
    padding: 2,
    display: 'block',
  },
  labelDisabled: {
    padding: 2,
    display: 'block',
    color: COLORS.MAIN_GRAY,
  },
};

export default function FormCheckbox(props) {
  const { t, i18n } = useTranslation();
  const label = props.label || '';
  const last = !!props.last;
  const { error } = props;
  var errorMessage = '';
  if (error) {
    errorMessage = error == '*' ? '*' : t(`validators.${error}`);
  }
  return (
    <div id={`${props.id}_container`} style={{ marginBottom: 5 }}>
      <Form.Group style={styles.group}>
        <Form.Check
          style={styles.checkbox}
          type='checkbox'
          checked={props.checked}
          onChange={props.onChange}
          disabled={props.disabled}
          id={props.id}
        />
        <div style={styles.labelWrapper}>
          <label
            style={props.disabled ? styles.labelDisabled : styles.label}
            htmlFor={props.id}>
            {props.label}{' '}
          </label>
          {props.error && (
            <div style={{ color: COLORS.MAIN_RED }}> {props.error} </div>
          )}
        </div>
      </Form.Group>
      {!last && (
        <div
          style={{
            width: '100%',
            height: 1,
            backgroundColor: COLORS.GRAY_OUTLINE,
          }}></div>
      )}
    </div>
  );
}

FormCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};
